export const REVIEW_EVENTS = {
  REVIEW_IMAGE_CLICKED: 'review_image_clicked',
};
